<template>
    <el-dialog
        :title="titleText"
        :visible.sync="visible"
        top="5vh"
        custom-class="course-dialog"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        width="80%">

        <div class="dialog-body">
            <div class="left-panel">
                <el-form class="query-form" ref="form" :model="form" label-position="top" size="medium">
                    <el-form-item :label="$t('c.name')">
                        <el-input v-model="form.title" @keyup.enter.native="query(1)" clearable></el-input>
                    </el-form-item>

                    <select-multi-knowledge v-if="visible" @knowledgeChange="knowledgeChange"></select-multi-knowledge>

                    <select-multiple v-if="visible"
                                     :nameArrays="selectNames"
                                     v-on:getForLevelVal="getForLevelVal">
                    </select-multiple>

                    <el-form-item :label="$t('c.type')">
                        <el-radio-group v-model="form.types" size="small">
                            <el-radio-button label="">全部</el-radio-button>
                            <!-- 课件 -->
                            <template v-if="type===1">
                                <el-radio-button v-for="item in courseTypeMenu"
                                                 :label="item.id"
                                                 :key="item.id">{{item.value}}
                                </el-radio-button>
                            </template>
                            <!-- 考卷、模拟考卷 -->
                            <template v-else>
                                <el-radio-button v-for="item in paperTypeMenu"
                                                 :label="item.id"
                                                 :key="item.id">{{item.value}}
                                </el-radio-button>
                            </template>

                        </el-radio-group>
                    </el-form-item>

                    <el-button class="btn-query" @click="query(1)" size="medium" icon="el-icon-search">
                        {{$t('c.query')}}
                    </el-button>
                </el-form>
            </div>
            <div class="right-panel" v-loading="loading">
                <el-row class="courseList" :gutter="20" >
                    <el-col class="courseList-item" v-for="item in courseList" :index="item.id" :key="item.id" :span="8">
                        <div class="courseList-wrap"
                             :class="{'selected': selectItems.includes(item.id)}"
                             @click.prevent="clickCard(item.id, item)">
                            <el-card>
                                <div class="item-header" slot="header">
                                    <h5>{{item.creatorName}}</h5>
                                    <el-tag type="primary" size="small">{{item.typeName}}</el-tag>
                                </div>
                                <div class="item-body">
                                    <h1>{{type===1 ? item.name: item.title}}</h1>
                                    <div class="bottom">
                                        <p v-if="type===1">{{item.knowledgeName}} <i>{{item.score}}</i> {{$t('train.credit')}}/ <i>{{item.hours}}</i>{{$t('train.hour')}}/ <i>{{item.usageCount}}</i> {{$t('train.times')}}</p>
                                        <p v-else>{{item.knowledgeName}} <i>{{item.passScore}}</i> {{$t('paper.passScore')}}/ <i>{{item.totalScore}}</i>{{$t('paper.totalScore')}}/ <i>{{item.useCount}}</i> {{$t('train.times')}}</p>
                                        <el-checkbox class="item-checkbox"
                                                     v-model="selectItems"
                                                     :label="item.id"
                                                     :disabled="disabled[item.id]"></el-checkbox>
                                    </div>
                                </div>
                            </el-card>
                        </div>
                    </el-col>
                </el-row>

                <div v-show="page.total">
                    <el-pagination
                        layout="prev, pager, next"
                        :page-size="page.pageSize"
                        :current-page="page.currentPage"
                        @current-change="currentChange"
                        :total="page.total">
                    </el-pagination>
                </div>

                <p v-show="!page.total" class="no-data">
                    <i class="nucfont inuc-empty-file"></i> {{$t('c.noData')}}
                </p>
            </div>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button @click="toNewTag" type="text">> {{type === 1 ? '前往 "我的课件"': '前往 "我的考卷"'}}</el-button>
            <div class="btn-group">
                <el-button @click="visible = false">{{$t('c.cancel')}}</el-button>
                <el-button type="success" @click="selectOver">{{$t('c.confirm')}}</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import {mapGetters} from 'vuex';
    import api from '@/api';
    import selectMultiKnowledge from '@components/SelectMultiKnowledge';

    export default {
        props: {
            type: {
                type: Number     // 1课件 2考卷 3模拟考卷
            },
            dialogOpen: {
                type: Boolean,
                default: false,
            },
            initData: {
                type: Object
            }
        },
        data() {
            return {
                forLevelAll: false,
                visible: false,
                page: {             //分页相关
                    currentPage: 1,
                    total: 0,
                    pageSize: 9
                },
                form: {
                    title: '',
                    knowledges: [0],
                    forLevels: [],
                    types: ''
                },
                selectNames: [
                    {
                        key: "forLevel",
                    }
                ],
                courseList:'',       //右边的课程数据
                selectItems: [],      //选中的项
                selectValue: [],
                loading: false,
                disabled: {}
            }
        },
        created() {
            this.$store.dispatch('getForLevelMenu');
            this.$store.dispatch('getCourseTypeMenu');
            this.$store.dispatch('getPaperTypeMenu');
        },
        computed: {
            ...mapGetters([
                'forLevelMenu',
                'courseTypeMenu',
                'paperTypeMenu',
            ]),
            titleText() {
                return ['', this.$t('train.chooseCourse'), this.$t('train.chooseTestPaper'), this.$t('train.chooseMockPaper')][this.type];
            }
        },
        methods: {
            // 打开对话框的事件
            initDialog() {
                this.page.currentPage = 1;

                this.selectItems = [];
                this.selectValue = [];

                this.initData.ids.forEach(item => {
                    if (item.type === this.type) {
                        this.selectItems.push(item.id);
                        this.disabled[item.id] = true;
                    }
                });
                //console.log(this.initData.ids)
                //console.log(this.selectItems)

                this.query();
            },
            resetDialog() {
                this.forLevelAll = false;
                this.form = {
                    title: '',
                    knowledges: [0],
                    forLevels: [],
                    types: ''
                };
                this.selectItems = [];
                this.disabled = {};
            },
            query(num) {
                this.loading = true;

                if (num) {
                    this.page.currentPage = 1;
                }

                let queryData = {
                    ...this.form,
                    limit: this.page.pageSize,
                    pageNo: this.page.currentPage,
                };

                this.forLevelAll && delete queryData.forLevels;

                if (this.form.knowledges.indexOf(0) > -1) {
                    delete queryData.knowledges;
                }

                if (this.type === 1) {
                    queryData.name = this.form.title;
                    delete queryData.title;
                    api.getCourse(queryData).then((res) => {
                        this.loading = false;
                        this.courseList = res.package;
                        this.courseList.forEach(val => {
                            val.resType = 1;
                            val.courseID = val.id;
                            val.credit = val.score;
                            val.title = val.name;
                        });
                        this.page.total = res.total;
                        this.page.total = res.total;
                    });
                } else {
                    api.getPapers(queryData).then((res) => {
                        this.loading = false;
                        this.courseList = res.package;
                        if (this.type === 2) {
                            this.courseList.forEach(val => {
                                val.resType = 2;
                                val.paperID = val.id;
                            });
                        } else {
                            this.courseList.forEach(val => {
                                val.resType = 3;
                                val.mockPaperID = val.id;
                            });
                        }
                        this.page.total = res.total;
                    });
                }
            },
            clickCard(id, data) {
                if (this.disabled[id]) return;

                let index = this.selectItems.indexOf(id);
                if (index < 0) {
                    this.selectItems.push(id);
                    this.selectValue.push(data);
                } else {
                    this.selectItems.splice(index, 1);
                    let idx = this.selectValue.findIndex(v => v.id === id);
                    this.selectValue.splice(idx, 1);
                }

            },
            selectOver() {
                this.$emit('onSelectOver', this.selectValue);
                this.visible = false;
            },

            getForLevelVal(data) {
                this.form.forlevels = data;
            },
            knowledgeChange(data) {
                this.form.knowledges = data;
            },
            currentChange(num) {
                this.page.currentPage = num;
                this.query();
            },

            toNewTag() {
                if (this.type === 1) {
                    window.open('/course/myCourse')
                } else {
                    window.open('/paper/my')
                }
            },
        },
        watch: {
            visible(val) {
                // 打开
                if (val) {
                    this.$nextTick(() => {
                        $('.sub-page').css({
                            overflow: 'hidden'
                        })
                    });

                    this.initDialog();

                // 关闭
                } else {
                    this.$emit('onDialogClosed', false);

                    $('.sub-page').css({
                        overflow: 'auto'
                    });

                    this.resetDialog();
                }
            },
            dialogOpen() {
                this.visible = this.dialogOpen;
            }
        },
        components: {
            selectMultiKnowledge
        }
    }
</script>

<style lang="scss">
    @import "../../../style/const";

    .course-dialog {
        min-width: 1000px;

        .el-dialog__header {
            padding: 10px 15px;
            border-bottom: 1px solid #ccc;
        }
        .el-dialog__body {
            padding-top: 20px;
            background-color: #F8F8F8;
        }
        .el-dialog__footer {
            padding: 10px 20px;
        }
        .el-card__body {
            padding: 15px 20px;
        }

        .dialog-body {
            display: flex;
        }

        .left-panel {
            width: 330px;
        }

        .dialog-footer {
            display: flex;
            justify-content: space-between;
            .btn-group {
                button {
                    min-width: 110px;
                    letter-spacing: 4px;
                }
            }
        }

        .right-panel {
            flex: 1;
            padding-left: 20px;
        }

        .el-form--label-top .el-form-item__label {
            padding: 0;
        }

        .query-form {
            padding: 10px 15px 20px 15px;
            border: 1px solid #e7eaec;
            background-color: #fff;
            box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);

            .el-form-item__label {
                font-size: 12px;
                line-height: 32px;
                color: #aaa;
            }

            .el-select {
                display: block;
            }

            .checkall-item {
                position: absolute;
                right: 10px;
                top: -35px;
                .el-checkbox__label {
                    font-size: 12px;
                }
            }

            .btn-query {
                display: block;
                margin-top: 30px;
                margin-bottom: 10px;
                width: 100%;
            }
        }

        .courseList {
            height: 540px;

            .courseList-item {
                //min-width: 390px;
                margin-bottom: 20px;
            }

            .courseList-wrap {
                cursor: pointer;
                .el-card {
                    transition: all .3s ease-in-out;
                }
                &.selected {
                    .el-card {
                        background-color: #ebf3fb;
                        box-shadow: none;
                    }
                    .el-card__header {
                        border-color: #e2e7f3;
                    }
                }
            }

            .el-card {
                height: 160px;
            }

            .el-card__header {
                padding: 10px 15px;
            }

            .item-header {
                display: flex;
                justify-content: space-between;
                align-items: center;

                > h5 {
                    font-size: 14px;
                    font-weight: 600;
                }
            }

            .item-body {

                > h1 {
                    max-width: 330px;
                    margin-bottom: 10px;
                    font-size: 20px;
                    font-weight: normal;
                    @include no-wrap;
                }

                .bottom {
                    display: flex;
                    justify-content: space-between;

                    > p {
                        font-size: 14px;
                        color: #aaa;
                        line-height: 1.4;
                        @include no-wrap-multi(3);
                    }
                }
            }

            .item-checkbox {
                padding-left: 15px;
                .el-checkbox__inner {
                    width: 20px;
                    height: 20px;
                    &::after {
                        top: 0;
                        left: 6px;
                        height: 12px;
                        width: 5px;
                    }
                }
                .el-checkbox__label {
                    display: none;
                }
            }
        }

        .el-select-dropdown__item {
            max-width: 250px;
        }

        .no-data {
            position: absolute;
            top: 50%;
            left: 55%;
        }
    }
</style>
